<template>
  <q-layout
    view="lHh Lpr lff"
    class="overflow-hidden bg-200 text-neutral-70 pl-[var(--Nv0-sidebar-width)]"
  >
    <HeaderBase />
    <MenuMultiLevel
      :menu-list="menuList(menu, t)"
      @click:botao-generico="
        $router.push({
          name: 'PageGeneric',
          params: { id: $event.id },
        })
      "
    />
    <q-page-container class="">
      <q-page class="flex flex-col container-base mx-auto">
        <router-view />
      </q-page>
    </q-page-container>
    <DevTricksCard v-if="DEV" />
  </q-layout>
</template>

<script setup>
import { DEV } from 'js/utils/constants/app'
import { onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import DevTricksCard from 'components/Dev/DevTricksCard.vue'
import HeaderBase from 'components/Header/HeaderBase.vue'
import menuList from 'js/utils/menuList'
import MenuMultiLevel from 'components/MenuMultiLevel/MenuMultiLevel.vue'
import useAssessment from 'composables/useAssessment'
import useMenu from 'composables/useMenu'

const { t } = useI18n()

const { initialRequests: initialRequestsMenu, menu } = useMenu()
const { initialRequests: initialRequestsAssessment } = useAssessment()

onMounted(() => {
  initialRequestsMenu()
  initialRequestsAssessment()
})
</script>

<style lang="sass" scoped></style>
